var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconModuleLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconModule",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1242.353 65v269.139l367.623 214.136c51.953 30.269 84.142 86.287 84.142 146.372v386.824H1920v564.705h-557.026l-317.703 185.111c-26.316 15.36-55.793 23.04-85.271 23.04s-58.955-7.68-85.27-23.04l-317.704-185.11H0V1081.47h225.882V694.647c0-60.085 32.302-116.216 84.142-146.372L677.647 334.14V65h564.706Zm0 399.812v164.894H677.647V464.812L366.833 645.856c-17.28 10.052-28.01 28.8-28.01 48.791v386.824h225.883v438.55l366.946 213.685c17.393 10.278 39.303 10.278 56.696 0l366.946-213.685v-438.55h225.882V694.647c0-19.99-10.842-38.739-28.122-48.79l-310.701-181.045Zm564.706 729.6h-338.824v338.823h338.824v-338.823Zm-1355.294 0H112.94v338.823h338.824v-338.823Zm677.647-1016.47H790.588v338.823h338.824V177.94Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconModuleLine.glyphName = 'module';
IconModuleLine.variant = 'Line';
IconModuleLine.displayName = 'IconModuleLine';
IconModuleLine.allowedProps = [...SVGIcon.allowedProps];
export default IconModuleLine;
export { IconModuleLine };